// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import PrepareAuditListItemInfo from './prepare-audit-list-item-info';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {buildNumber} from '../../../shared/services/build-number';

const AuditClaimListItem = props =>
    <section className='list-item'>
        <main>
            <div className='list-item-header'>
                <Link
                    className='claim-title'
                    rel='noopener noreferrer'
                    target='_blank'
                    to={buildClaimRoutes(props.item.claimType.key, props.item.subClaimType.key, props.item.claimNumber)}
                >
                    {props.item.claimNumber}
                </Link>
                <FormattedMessage
                    id='PERCENTAGE_SYMBOL'
                    values={{
                        percentage: buildNumber(props.item.reimbursementDetails.reimbursementPercentage)
                    }}
                />
            </div>
            <PrepareAuditListItemInfo auditClaim={props.item}/>
        </main>
        {props.children}
    </section>;

AuditClaimListItem.displayName = 'AuditClaimListItem';
AuditClaimListItem.propTypes = {
    children: PropTypes.node,
    item: PropTypes.instanceOf(AuditClaim).isRequired
};

export default AuditClaimListItem;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/audit-claim-list-item.js